// Public currency labels from the deployed registry; demo only. No price, reserve or payment capability is implied.
export const DEMO_CURRENCIES = [
  {
    "currency": "USD",
    "ticker": "USDO"
  },
  {
    "currency": "AED",
    "ticker": "AEDO"
  },
  {
    "currency": "AFN",
    "ticker": "AFNO"
  },
  {
    "currency": "ALL",
    "ticker": "ALLO"
  },
  {
    "currency": "AMD",
    "ticker": "AMDO"
  },
  {
    "currency": "ANG",
    "ticker": "ANGO"
  },
  {
    "currency": "AOA",
    "ticker": "AOAO"
  },
  {
    "currency": "ARS",
    "ticker": "ARSO"
  },
  {
    "currency": "AUD",
    "ticker": "AUDO"
  },
  {
    "currency": "AWG",
    "ticker": "AWGO"
  },
  {
    "currency": "AZN",
    "ticker": "AZNO"
  },
  {
    "currency": "BAM",
    "ticker": "BAMO"
  },
  {
    "currency": "BBD",
    "ticker": "BBDO"
  },
  {
    "currency": "BDT",
    "ticker": "BDTO"
  },
  {
    "currency": "BGN",
    "ticker": "BGNO"
  },
  {
    "currency": "BHD",
    "ticker": "BHDO"
  },
  {
    "currency": "BIF",
    "ticker": "BIFO"
  },
  {
    "currency": "BMD",
    "ticker": "BMDO"
  },
  {
    "currency": "BND",
    "ticker": "BNDO"
  },
  {
    "currency": "BOB",
    "ticker": "BOBO"
  },
  {
    "currency": "BRL",
    "ticker": "BRLO"
  },
  {
    "currency": "BSD",
    "ticker": "BSDO"
  },
  {
    "currency": "BTN",
    "ticker": "BTNO"
  },
  {
    "currency": "BWP",
    "ticker": "BWPO"
  },
  {
    "currency": "BYN",
    "ticker": "BYNO"
  },
  {
    "currency": "BZD",
    "ticker": "BZDO"
  },
  {
    "currency": "CAD",
    "ticker": "CADO"
  },
  {
    "currency": "CDF",
    "ticker": "CDFO"
  },
  {
    "currency": "CHF",
    "ticker": "CHFO"
  },
  {
    "currency": "CLP",
    "ticker": "CLPO"
  },
  {
    "currency": "CNY",
    "ticker": "CNYO"
  },
  {
    "currency": "COP",
    "ticker": "COPO"
  },
  {
    "currency": "CRC",
    "ticker": "CRCO"
  },
  {
    "currency": "CUP",
    "ticker": "CUPO"
  },
  {
    "currency": "CVE",
    "ticker": "CVEO"
  },
  {
    "currency": "CZK",
    "ticker": "CZKO"
  },
  {
    "currency": "DJF",
    "ticker": "DJFO"
  },
  {
    "currency": "DKK",
    "ticker": "DKKO"
  },
  {
    "currency": "DOP",
    "ticker": "DOPO"
  },
  {
    "currency": "DZD",
    "ticker": "DZDO"
  },
  {
    "currency": "EGP",
    "ticker": "EGPO"
  },
  {
    "currency": "ERN",
    "ticker": "ERNO"
  },
  {
    "currency": "ETB",
    "ticker": "ETBO"
  },
  {
    "currency": "EUR",
    "ticker": "EURO"
  },
  {
    "currency": "FJD",
    "ticker": "FJDO"
  },
  {
    "currency": "FKP",
    "ticker": "FKPO"
  },
  {
    "currency": "GBP",
    "ticker": "GBPO"
  },
  {
    "currency": "GEL",
    "ticker": "GELO"
  },
  {
    "currency": "GGP",
    "ticker": "GGPO"
  },
  {
    "currency": "GHS",
    "ticker": "GHSO"
  },
  {
    "currency": "GIP",
    "ticker": "GIPO"
  },
  {
    "currency": "GMD",
    "ticker": "GMDO"
  },
  {
    "currency": "GNF",
    "ticker": "GNFO"
  },
  {
    "currency": "GTQ",
    "ticker": "GTQO"
  },
  {
    "currency": "GYD",
    "ticker": "GYDO"
  },
  {
    "currency": "HKD",
    "ticker": "HKDO"
  },
  {
    "currency": "HNL",
    "ticker": "HNLO"
  },
  {
    "currency": "HTG",
    "ticker": "HTGO"
  },
  {
    "currency": "HUF",
    "ticker": "HUFO"
  },
  {
    "currency": "IDR",
    "ticker": "IDRO"
  },
  {
    "currency": "ILS",
    "ticker": "ILSO"
  },
  {
    "currency": "INR",
    "ticker": "INRO"
  },
  {
    "currency": "IQD",
    "ticker": "IQDO"
  },
  {
    "currency": "IRR",
    "ticker": "IRRO"
  },
  {
    "currency": "ISK",
    "ticker": "ISKO"
  },
  {
    "currency": "JMD",
    "ticker": "JMDO"
  },
  {
    "currency": "JOD",
    "ticker": "JODO"
  },
  {
    "currency": "JPY",
    "ticker": "JPYO"
  },
  {
    "currency": "KES",
    "ticker": "KESO"
  },
  {
    "currency": "KGS",
    "ticker": "KGSO"
  },
  {
    "currency": "KHR",
    "ticker": "KHRO"
  },
  {
    "currency": "KMF",
    "ticker": "KMFO"
  },
  {
    "currency": "KPW",
    "ticker": "KPWO"
  },
  {
    "currency": "KRW",
    "ticker": "KRWO"
  },
  {
    "currency": "KWD",
    "ticker": "KWDO"
  },
  {
    "currency": "KYD",
    "ticker": "KYDO"
  },
  {
    "currency": "KZT",
    "ticker": "KZTO"
  },
  {
    "currency": "LAK",
    "ticker": "LAKO"
  },
  {
    "currency": "LBP",
    "ticker": "LBPO"
  },
  {
    "currency": "LKR",
    "ticker": "LKRO"
  },
  {
    "currency": "LRD",
    "ticker": "LRDO"
  },
  {
    "currency": "LSL",
    "ticker": "LSLO"
  },
  {
    "currency": "LYD",
    "ticker": "LYDO"
  },
  {
    "currency": "MAD",
    "ticker": "MADO"
  },
  {
    "currency": "MDL",
    "ticker": "MDLO"
  },
  {
    "currency": "MGA",
    "ticker": "MGAO"
  },
  {
    "currency": "MKD",
    "ticker": "MKDO"
  },
  {
    "currency": "MMK",
    "ticker": "MMKO"
  },
  {
    "currency": "MNT",
    "ticker": "MNTO"
  },
  {
    "currency": "MOP",
    "ticker": "MOPO"
  },
  {
    "currency": "MRU",
    "ticker": "MRUO"
  },
  {
    "currency": "MUR",
    "ticker": "MURO"
  },
  {
    "currency": "MVR",
    "ticker": "MVRO"
  },
  {
    "currency": "MWK",
    "ticker": "MWKO"
  },
  {
    "currency": "MXN",
    "ticker": "MXNO"
  },
  {
    "currency": "MYR",
    "ticker": "MYRO"
  },
  {
    "currency": "MZN",
    "ticker": "MZNO"
  },
  {
    "currency": "NAD",
    "ticker": "NADO"
  },
  {
    "currency": "NGN",
    "ticker": "NGNO"
  },
  {
    "currency": "NIO",
    "ticker": "NIOO"
  },
  {
    "currency": "NOK",
    "ticker": "NOKO"
  },
  {
    "currency": "NPR",
    "ticker": "NPRO"
  },
  {
    "currency": "NZD",
    "ticker": "NZDO"
  },
  {
    "currency": "OMR",
    "ticker": "OMRO"
  },
  {
    "currency": "PEN",
    "ticker": "PENO"
  },
  {
    "currency": "PGK",
    "ticker": "PGKO"
  },
  {
    "currency": "PHP",
    "ticker": "PHPO"
  },
  {
    "currency": "PKR",
    "ticker": "PKRO"
  },
  {
    "currency": "PLN",
    "ticker": "PLNO"
  },
  {
    "currency": "PYG",
    "ticker": "PYGO"
  },
  {
    "currency": "QAR",
    "ticker": "QARO"
  },
  {
    "currency": "RON",
    "ticker": "RONO"
  },
  {
    "currency": "RSD",
    "ticker": "RSDO"
  },
  {
    "currency": "RUB",
    "ticker": "RUBO"
  },
  {
    "currency": "RWF",
    "ticker": "RWFO"
  },
  {
    "currency": "SAR",
    "ticker": "SARO"
  },
  {
    "currency": "SBD",
    "ticker": "SBDO"
  },
  {
    "currency": "SCR",
    "ticker": "SCRO"
  },
  {
    "currency": "SDG",
    "ticker": "SDGO"
  },
  {
    "currency": "SEK",
    "ticker": "SEKO"
  },
  {
    "currency": "SGD",
    "ticker": "SGDO"
  },
  {
    "currency": "SHP",
    "ticker": "SHPO"
  },
  {
    "currency": "SLL",
    "ticker": "SLLO"
  },
  {
    "currency": "SOS",
    "ticker": "SOSO"
  },
  {
    "currency": "SRD",
    "ticker": "SRDO"
  },
  {
    "currency": "SSP",
    "ticker": "SSPO"
  },
  {
    "currency": "STN",
    "ticker": "STNO"
  },
  {
    "currency": "SYP",
    "ticker": "SYPO"
  },
  {
    "currency": "SZL",
    "ticker": "SZLO"
  },
  {
    "currency": "THB",
    "ticker": "THBO"
  },
  {
    "currency": "TJS",
    "ticker": "TJSO"
  },
  {
    "currency": "TMT",
    "ticker": "TMTO"
  },
  {
    "currency": "TND",
    "ticker": "TNDO"
  },
  {
    "currency": "TOP",
    "ticker": "TOPO"
  },
  {
    "currency": "TRY",
    "ticker": "TRYO"
  },
  {
    "currency": "TTD",
    "ticker": "TTDO"
  },
  {
    "currency": "TWD",
    "ticker": "TWDO"
  },
  {
    "currency": "TZS",
    "ticker": "TZSO"
  },
  {
    "currency": "UAH",
    "ticker": "UAHO"
  },
  {
    "currency": "UGX",
    "ticker": "UGXO"
  },
  {
    "currency": "UYU",
    "ticker": "UYUO"
  },
  {
    "currency": "UZS",
    "ticker": "UZSO"
  },
  {
    "currency": "VES",
    "ticker": "VESO"
  },
  {
    "currency": "VND",
    "ticker": "VNDO"
  },
  {
    "currency": "VUV",
    "ticker": "VUVO"
  },
  {
    "currency": "XAF",
    "ticker": "XAFO"
  },
  {
    "currency": "XCD",
    "ticker": "XCDO"
  },
  {
    "currency": "XOF",
    "ticker": "XOFO"
  },
  {
    "currency": "XPF",
    "ticker": "XPFO"
  },
  {
    "currency": "YER",
    "ticker": "YERO"
  },
  {
    "currency": "ZAR",
    "ticker": "ZARO"
  },
  {
    "currency": "ZMW",
    "ticker": "ZMWO"
  },
  {
    "currency": "ZWL",
    "ticker": "ZWLO"
  }
] as const;
